import Swal from "sweetalert2";

const ConfirmationDeleteList = (callback) => {
    Swal.fire({
        title: "Atenção",
        html: 'Para confirmar exclusão, digite <b>excluir</b> abaixo:',
        icon: "warning",
        input: "text",
        confirmButtonText: "Confirmar",
        confirmButtonColor: "#063A6C",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        reverseButtons: true,
        preConfirm(inputValue) {
            if (inputValue.trim() !== "excluir") {
                Swal.showValidationMessage("Digite corretamente a palavra-chave");
            }
        }
    }).then(({isConfirmed}) => {
        if (isConfirmed) {
            callback()
        }
    });
};

export default ConfirmationDeleteList;